<div class="d-flex flex-column">
    <p class="mx-3 mt-sm-2 mt-3 mb-1 typography-label-large-strong">{{labels.Title}}</p>
    <mbsc-datepicker class="d-grid d-sm-block w-100"
        (click)="Clicked($event)"
        [controls]="['time']"
        select="range"
        [timeFormat]="timeFormat"
        [amText]="amDesignator"
        [pmText]="pmDesignator"
        [minTime]="minimumHour.toString() + ':00'"
        [maxTime]="maximumHour.toString() + ':59'"
        [stepMinute]="minuteStep"
        display="inline"
        themeVariant="light"
        [showRangeLabels]="true"
        [touchUi]="!isDesktop"
        [focusOnClose]="false"
        [scrollLock]="false"
        [attr.placeholder]="placeholderText"
        [rangeStartLabel]="labels.StartLabel"
        [rangeEndLabel]="labels.EndLabel"
        [rangeStartHelp]="labels.StartHelperText"
        [rangeEndHelp]="labels.EndHelperText"
        (onTempChange)="TimeChanged()"
        theme="ios">
    </mbsc-datepicker>
    <div class="d-flex gap-2 mx-3 my-1">
        <div class="w-100">
            <lib-button [kind]="ButtonKind.Secondary" [stretch]="true" (clicked)="ResetTimeRange()">
                <ng-container label i18n="@@CommonClear">Clear</ng-container>
            </lib-button>
        </div>
        <div class="w-100">
            <lib-button [kind]="ButtonKind.Primary" [stretch]="true" (clicked)="ApplyClicked()">
                <ng-container label i18n="@@CommonApplyButton">Apply</ng-container>
            </lib-button>
        </div>
    </div>
</div>
